import { ArrowLeftOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Typography, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setBreadcrumbItems } from "../../store/actions";

const { Text } = Typography;

const AddCollateral = ({ setBreadcrumbItems }) => {
  const [collateralName, setcollateralName] = useState("");
  const [collateralDescription, setcollateralDescription] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;


  const breadcrumbItems = [
    { title: "Form & Collaterals", link: "#" },
    { title: "Collateral", link: "#" },
    { title: "Add Collateral", link: "#" }
  ];

  useEffect(() => {
    setBreadcrumbItems("Collaterals", breadcrumbItems);
  }, [setBreadcrumbItems, breadcrumbItems]);


  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setPdfFile(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "application/pdf": [".pdf"] },
    multiple: false,
  });

  const handleSubmit = async () => {
    if (!collateralName || !collateralDescription || !pdfFile) {
      message.error("Please fill all fields and upload a PDF.");
      return;
    }

    try {
      const collateralData = new FormData();
      collateralData.append("collateralName", collateralName);
      collateralData.append("collateralDescription", collateralDescription);
      collateralData.append("pdfs", pdfFile);

      await axios.post(`${process.env.REACT_APP_API_BASEURL}/collateral`, collateralData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      message.success("Collateral added successfully");
      navigate("/collaterals");
    } catch (error) {
      console.error(" upload error:", error.response?.data || error.message);
      message.error("Failed to add form");
    }
  };

  return (
    <div className="p-4">
      <Card title="Add Collateral">
        <Row gutter={16}>
          <Col span={12}>
            <Text strong>Collateral Name</Text>
            <Input
              placeholder="AC / Cooler"
              value={collateralName}
              onChange={(e) => setcollateralName(e.target.value)}
              style={{ marginBottom: 20 }}
            />
          </Col>
          <Col span={12}>
            <Text strong>Description</Text>
            <Input
              placeholder="About Colletral"
              value={collateralDescription}
              onChange={(e) => setcollateralDescription(e.target.value)}
              style={{ marginBottom: 20 }}
            />
          </Col>
        </Row>

        <Text strong>Collateral PDF</Text>
        <div
          {...getRootProps()}
          style={{
            border: "2px dashed #d9d9d9",
            padding: "40px",
            textAlign: "center",
            marginBottom: "20px",
            borderRadius: "8px",
            cursor: "pointer",
            backgroundColor: isDragActive ? "#fafafa" : "#fff",
          }}
        >
          <input {...getInputProps()} />
          <img
            src="https://cdn-icons-png.flaticon.com/512/1828/1828491.png"
            alt="Upload"
            style={{ width: "40px", marginBottom: "10px", opacity: 0.5 }}
          />

          <div style={{ fontWeight: 600, fontSize: "16px" }}>
            {isDragActive ? "Drop the file here..." : "Drop file here to upload"}
          </div>
        </div>

        {pdfFile && (
          <div style={{ marginBottom: 20 }}>
            <Text>
              Selected File:{" "}
              <a
                href={URL.createObjectURL(pdfFile)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {pdfFile.name}
              </a>
            </Text>
          </div>
        )}

        <Row gutter={16}>
          <Col>
            <Button type="primary" icon={<PlusOutlined />} style={{ backgroundColor: PRIMARY_RED }} onClick={handleSubmit}>
              Add Collateral
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              style={{ color: PRIMARY_RED }}
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/collaterals")}
            >
              Back
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(AddCollateral);

